<template>
  <v-card>
    <v-card-title>Tariff Details</v-card-title>
    <v-card-text>
      <v-row>
        <v-col>
          <p>This product uses a legacy tariff, please use the old CRM to <a @click="topMenuClicked('viewOnOldCrm')">view the tariff</a></p>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
  export default {
    
  }
</script>

<style lang="scss" scoped></style>
